"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var LinearProgress = function (_a) {
    var _b = _a.height, height = _b === void 0 ? '10px' : _b, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? '#cac9d4' : _c, _d = _a.marginTop, marginTop = _d === void 0 ? '5px' : _d, props = __rest(_a, ["height", "backgroundColor", "marginTop"]);
    return (react_1.default.createElement(material_1.LinearProgress, __assign({}, props, { sx: {
            height: height,
            backgroundColor: backgroundColor,
            marginTop: marginTop,
            '& .MuiLinearProgress-bar': {
                backgroundColor: props.color,
            },
        } })));
};
exports.default = LinearProgress;
